<div class="step-panel">

  <div class="pg-title">
    KFS delivery
    <span class="badge b-b" style="vertical-align:middle;margin-left:8px">RBI DL-2022 Mandatory</span>
  </div>
  <div class="pg-sub">
    Key Fact Statement must be delivered and acknowledged before agreement execution.
    Mandated under RBI Digital Lending Guidelines (Sep 2022).
  </div>

  <!-- KFS BOX -->
  <div class="kfs-box">
    <div class="kfs-hdr">
      <div class="t">Key Fact Statement (KFS)</div>
      <div class="s">RBI Digital Lending Guidelines 2022 · {{ applicationData?.prrn || 'NWK-2024-09812' }}</div>
    </div>
    <div class="kfs-body">
      <table class="kfs-tbl">
        <tr><td class="kl">Lender name</td><td class="kv">{{ productData?.otherDetail1 || 'InCred Finance Limited (NBFC — RBI registered)' }}</td></tr>
        <tr><td class="kl">Loan amount</td><td class="kv">{{ loanAmount | currency:'INR':'symbol':'1.0-0' }}</td></tr>
        <tr><td class="kl">Annual Percentage Rate (APR)</td><td class="kv" style="color:var(--rose)">{{ apr | number:'1.1-1' }}% p.a. (incl. all fees — true cost)</td></tr>
        <tr><td class="kl">Interest rate</td><td class="kv">{{ interestRatePct | number:'1.1-2' }}% p.a. (reducing balance)</td></tr>
        <tr><td class="kl">Tenure</td><td class="kv">{{ tenureMonths }} months</td></tr>
        <tr><td class="kl">Monthly EMI</td><td class="kv">{{ emi | currency:'INR':'symbol':'1.0-0' }}</td></tr>
        <tr><td class="kl">Processing fee</td><td class="kv">{{ processingFeeRaw | currency:'INR':'symbol':'1.0-0' }} + 18% GST = {{ processingFeeTotal | currency:'INR':'symbol':'1.0-0' }}</td></tr>
        <tr><td class="kl">Total interest cost</td><td class="kv">{{ totalInterest | currency:'INR':'symbol':'1.0-0' }}</td></tr>
        <tr><td class="kl">Total cost of credit (TCC)</td><td class="kv">{{ totalCostOfCredit | currency:'INR':'symbol':'1.0-0' }} (loan + interest + all fees)</td></tr>
        <tr><td class="kl">Penal interest on default</td><td class="kv">{{ productData?.penaltyInterestRate || 2 }}% per month on overdue EMI amount</td></tr>
        <tr><td class="kl">Pre-payment charges</td><td class="kv">NIL after 6 EMIs · Before 6 EMIs: {{ productData?.preclosureChargesPercent || 2 }}% of outstanding</td></tr>
        <tr><td class="kl">Disbursal destination</td><td class="kv">Directly to {{ applicationData?.businessName || 'Greenwood Intl. School' }} — {{ maskedBankAccount }}</td></tr>
        <tr><td class="kl">Disbursal timeline</td><td class="kv">Within 1 working day of mandate activation</td></tr>
        <tr><td class="kl">Grievance email</td><td class="kv">grievance&#64;nishwik.in</td></tr>
        <tr><td class="kl">Grievance helpline</td><td class="kv">1800-XXX-XXXX (toll-free · Mon–Fri 9am–6pm)</td></tr>
        <tr><td class="kl">NBFC Ombudsman</td><td class="kv">cms.rbi.org.in (RBI Integrated Ombudsman)</td></tr>
      </table>
      <div class="kfs-warn">
        ⚠ <strong>Important:</strong> The APR ({{ apr | number:'1.1-1' }}%) is the true cost of credit
        and is higher than the stated interest rate ({{ interestRatePct | number:'1.1-2' }}%) because it includes the
        processing fee. Please read all terms carefully before accepting this loan offer.
        You have 3 days to reconsider this offer before it lapses.
      </div>
    </div>
  </div>

  <!-- DELIVERY CARD -->
  <div class="card">
    <div class="card-title">
      <div class="ct-bar"></div>
      KFS delivery + acknowledgement
    </div>
    <div class="sms-box" style="margin-bottom:12px">
      <div class="sms-top">SMS + email to borrower</div>
      <div class="sms-msg">
        Hi {{ borrowerFirstName }}, please review your Key Fact Statement before signing.
        This shows the true cost of your Nishwik loan:<br><br>
        <span class="sms-link">https://nishwik.in/kfs/{{ applicationData?.prrn || 'NWK-2024-09812' }}</span>
        <br><br>You must acknowledge this before signing the agreement.
      </div>
    </div>
    <div style="display:flex;gap:8px;flex-wrap:wrap">
      <button class="btn btn-pri" (click)="sendKfs()" [disabled]="isLoading">Send KFS to borrower</button>
      <button class="btn btn-sec btn-sm" (click)="simulateAck()" [disabled]="isLoading">Simulate acknowledgement ↗</button>
      <button class="btn btn-sec btn-sm" [disabled]="isLoading">Download KFS PDF</button>
    </div>
    <div *ngIf="ackReceived" class="alert ok" style="margin-top:12px;margin-bottom:0">
      <span style="flex-shrink:0">✓</span>
      <span>Borrower acknowledged KFS at {{ ackTime }} IST · IP 103.XX.XX.42 logged</span>
    </div>
  </div>

  <div class="nav-bar">
    <button class="btn btn-sec" (click)="prev.emit()" [disabled]="isLoading">← Back</button>
    <button class="btn btn-pri btn-lg" (click)="proceed()" [disabled]="isLoading || !ackReceived">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
      KFS acknowledged → eStamp →
    </button>
  </div>

</div>

